var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.43956328px",
    height: "10.7401253px",
    viewBox: "0 0 9.43956328 10.7401253",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E6FD84EE-036F-482F-845A-432978E751E7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prospecting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospect-Details--Comments",
    transform: "translate(-118.0405, -320.8918)",
    fill: "#9FAABE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(107.8515, 81.0942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(10.1891, 239.7976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71978164,0 C3.15828908,0 1.88791266,1.27037643 1.88791266,2.83186898 C1.88791266,4.39336154 3.15828908,5.66373797 4.71978164,5.66373797 C6.2812742,5.66373797 7.55165063,4.39336154 7.55165063,2.83186898 C7.55165063,1.27037643 6.2812742,0 4.71978164,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24317205,7.51378749 C7.46786926,6.72656986 6.44006863,6.29304219 5.34908586,6.29304219 L4.09047742,6.29304219 C2.99951563,6.29304219 1.97169402,6.72656986 1.19639123,7.51378749 C0.424885232,8.29714538 0,9.33117612 0,10.4254732 C0,10.5992451 0.140880238,10.7401253 0.314652109,10.7401253 L9.12491117,10.7401253 C9.29868304,10.7401253 9.43956328,10.5992451 9.43956328,10.4254732 C9.43956328,9.33117612 9.01467805,8.29714538 8.24317205,7.51378749 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ed1ef32f04f8f3e2c97622fe15ec0009.svg";
export { ForwardRef as ReactComponent };